// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockFragmentDoc } from '../../../../components/cms/CmsBlock.fragment.generated';
import { MoneyFragmentDoc } from '../../../../graphql/api/fragments/money.fragment.generated';
import { EngagementRingStoneRecommendationCardFragmentDoc } from './engagementRingStoneRecommendationCard.fragment.generated';
import { StoneFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/stone.fragment.generated';
import { StoneRecommendationsNotFoundFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/stoneRecommendationsNotFound.fragment.generated';
import { NonSkuGemstoneFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { NonSkuLabGrownFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const StoneRecommendationsFragmentDoc = gql`
    fragment stoneRecommendations on StoneRecommendationsResponse {
  ... on StoneRecommendationsResponseSuccess {
    priceBounds {
      min {
        ...money
      }
      max {
        ...money
      }
    }
    priceInitialValues @skip(if: $hasPrice) {
      min {
        ...money
      }
      max {
        ...money
      }
    }
    naturalDiamondBestForBalance {
      ... on GemsApi_Stone {
        ...stone
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    naturalDiamondBestForSize {
      ... on GemsApi_Stone {
        ...stone
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    nonSkuGemStones {
      color {
        systemCode
        translation(locale: $locale) {
          name
        }
      }
      item {
        ... on NonSkuGemstone {
          ...nonSkuGemstone
        }
        ... on StoneRecommendationNotFound {
          ...stoneRecommendationsNotFound
        }
      }
    }
    nonSkuLabGrownBestForPrice {
      ... on NonSkuLabGrown {
        ...nonSkuLabGrown
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    nonSkuLabGrownBestForSize {
      ... on NonSkuLabGrown {
        ...nonSkuLabGrown
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
  }
  ... on StoneRecommendationsResponseFailure {
    error
  }
}
    ${MoneyFragmentDoc}
${StoneFragmentDoc}
${StoneRecommendationsNotFoundFragmentDoc}
${NonSkuGemstoneFragmentDoc}
${NonSkuLabGrownFragmentDoc}`;
export const RingBuilderStoneRecommendationsFragmentDoc = gql`
    fragment ringBuilderStoneRecommendations on RingBuilderFragment {
  __typename
  ... on RingBuilderMountFragment {
    id
    stoneRecommendations(
      minPrice: $minPrice
      maxPrice: $maxPrice
      region: $region
      currency: $currency
    ) {
      __typename
      ...stoneRecommendations
    }
  }
  ... on RingBuilderCentreStoneFragment {
    id
  }
}
    ${StoneRecommendationsFragmentDoc}`;
export const StoneRecommendationsDocument = gql`
    query stoneRecommendations($minPrice: MoneyInput, $maxPrice: MoneyInput, $locale: Locale!, $currency: CurrencyInput!, $region: RegionCode!, $hasPrice: Boolean!) {
  ringBuilder {
    __typename
    id
    position1 {
      ...ringBuilderStoneRecommendations
    }
    position2 {
      ...ringBuilderStoneRecommendations
    }
  }
  cms: engagementRingStoneRecommendations(locale: $locale) {
    __typename
    fullSearchButtonText
    blocks {
      ...block
    }
    naturalDiamonds {
      forSizeCard {
        ...engagementRingStoneRecommendationCard
      }
      forBalanceCard {
        ...engagementRingStoneRecommendationCard
      }
      labGrownAlternative {
        ...engagementRingStoneRecommendationCard
      }
    }
    nonSkuLabGrown {
      forSizeCard {
        ...engagementRingStoneRecommendationCard
      }
      forPriceCard {
        ...engagementRingStoneRecommendationCard
      }
      naturalDiamondAlternative {
        ...engagementRingStoneRecommendationCard
      }
    }
    nonSkuGemStones {
      content {
        ...engagementRingStoneRecommendationCard
      }
      color
    }
  }
}
    ${RingBuilderStoneRecommendationsFragmentDoc}
${BlockFragmentDoc}
${EngagementRingStoneRecommendationCardFragmentDoc}`;

export function useStoneRecommendationsQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.StoneRecommendationsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.StoneRecommendationsQuery, SchemaTypes.StoneRecommendationsQueryVariables | undefined>({ query: StoneRecommendationsDocument, variables: undefined, ...options });
};